module.exports = __webpack_public_path__ + "static/img/patho-cocci-item-D-zfDzZR.6fd15974.png";